module.exports = __webpack_public_path__ + "79a6b0cf44685cf341459611a21566a2.svg";